// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ffb710d0f5c2d5543297","293":"999d5c44b6469140d267","518":"5b60bb56ac0bd9e2a77d","779":"f2859cbbdae081dc51a6"}[chunkId] + ".js";
};